(function($) {
    $(() => {
        $('.counseling-content-section__read-more-toggle').on('click', function () {
            $(this).parent().find('.counseling-content-section__read-more-text').slideToggle(700, 'swing', () => {
                $(this).toggleClass('show');
                var y = $(window).scrollTop();  //your current y position on the page
                $(window).scrollTop(y+1);
            });
        });

        $('.counseling-content-slide__read-more-toggle').on('click', function () {
            $(this).parent().find('.counseling-content-slide__read-more-text').slideToggle(400, 'swing', () => {
                $(this).toggleClass('show');
            });
        });

        $('.image-wrapper').on('click', function () {
            if(!$(this).hasClass('open')) {
                $(this).toggleClass('z-1 open');
                setTimeout(() => $(this).find('p').addClass('show'), 500)
            }
        });

        $('.image-wrapper__close').on('click', function (e) {
            e.stopPropagation();
            $(this).parent().removeClass('open');
            $(this).parent().find('p').removeClass('show');
            $(this).parent().find('p').addClass('d-none');
            setTimeout(() => {
                $(this).parent().find('p').removeClass('d-none');
                $(this).parent().removeClass('z-1')
            }, 500)
        });


        const slider = $('.services-archive-slider');

        slider.on('init reInit', function(event, slick) {
            $('.services-archive-slider__total-count').html(`1/${slick.slideCount}`);
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            $('.services-archive-slider__total-count').html(`${currentSlide + 1}/${slick.slideCount}`);

            $('.services-archive-slider-container').css('background-image', `url("${$('.slick-active .container').data('image')}"`);
        });

        slider.slick(
            {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                nextArrow:  $('.services-archive-slider__right'),
                prevArrow:  $('.services-archive-slider__left'),
            }
        );


        if ($('.counseling-container').length) {
            $('.counseling-content-section').each(function (i) {
                $(this).find('.counseling-content-section__image').css('height', `${$(this).find('.container').innerHeight() + 300 + $(this).find('.counseling-content-section__read-more-text').innerHeight() + 40}px`);
            });
        }
    });
})(jQuery);